var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#D30000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4123 32.5975H44.9996C44.9996 25.9862 39.9893 21 33.3438 21V23.5775C38.5986 23.5775 42.4123 27.3703 42.4123 32.5975Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.087 28.0533C36.8391 28.0533 38.013 29.2227 38.013 31.9643H40.6303C40.6303 27.7599 38.3075 25.4459 34.087 25.4459V28.0533ZM38.5653 35.1493C38.3138 34.9216 37.9834 34.8001 37.6437 34.8106C37.3041 34.8211 36.9818 34.9626 36.7449 35.2053L33.6133 38.4137C32.8595 38.2703 31.344 37.7997 29.7841 36.2496C28.2242 34.6943 27.7518 33.1807 27.6117 32.435L30.8297 29.3139C31.0737 29.0781 31.216 28.757 31.2265 28.4186C31.237 28.0801 31.1149 27.7509 30.886 27.5005L26.0505 22.2036C25.8215 21.9524 25.5033 21.8001 25.1634 21.7789C24.8235 21.7577 24.4887 21.8694 24.2302 22.0902L21.3904 24.5163C21.1641 24.7425 21.0291 25.0436 21.0108 25.3624C20.9912 25.6884 20.6169 33.4088 26.6263 39.398C31.8688 44.6193 38.4357 45.0013 40.2443 45.0013C40.5086 45.0013 40.6709 44.9935 40.7141 44.9909C41.0341 44.973 41.3361 44.8379 41.5621 44.6115L43.9962 41.7812C44.218 41.5237 44.3303 41.1903 44.3093 40.8517C44.2883 40.5131 44.1356 40.196 43.8837 39.9677L38.5653 35.1493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotline);
export default __webpack_public_path__ + "static/media/hotline.9ec9a0846d0ed61fc28ffd84e33d1384.svg";
export { ForwardRef as ReactComponent };